import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubjectService } from './shared/services/behaviorSubject.service';
import { LoadingService } from './shared/services/loading.service';
import { environment } from '../environments/environment';
import { KeyPressedHandlerService } from './shared/services/key-pressed-handler.service';
import { BreadcrumbService } from './shared/services/breadcrumb/breadcrumb.service';
import { GeocoderService } from './shared/component/select-map-location/geocoder.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'SISEM-FrontWeb';
  private lastVH = -1;
  private lastVW = -1;

  constructor(
    public loadingService: LoadingService,
    private behaviorSubjectService: BehaviorSubjectService,
    private keyPressedHandlerService: KeyPressedHandlerService,
    private breadcrumbService: BreadcrumbService,
    private geocoderService: GeocoderService
  ) {}

  ngAfterViewInit(): void {
    this.keyPressedHandlerService.initHostListener();
    this.geocoderService.testApiKey().then();
  }

  ngOnInit() {
    this.breadcrumbService.initializeSubscription();
    /**
     *capture the size of the viewport height
     *calculate the equivalence to 1vh and
     *save the value creating a css variable
     */
    const calculateViewport = () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      let vw = window.innerWidth * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      this.behaviorSubjectService.bSubjectSizeScreen.next(vw);
      this.behaviorSubjectService.bSubjectSizeScreenGlobal.next(vw);
      this.behaviorSubjectService.screenHeight.next(vh);
      return { vh, vw };
    };
    window.addEventListener('resize', calculateViewport);
    let eventFired = false;
    window.addEventListener('orientationchange', () => {
      if (eventFired) {
        return;
      }
      eventFired = true;
      let running = true;
      for (const delay of [50, 100, 200, 300, 500, 800, 1000]) {
        setTimeout(() => {
          if (running) {
            const { vh, vw } = calculateViewport();
            if (vh !== this.lastVH || vw !== this.lastVW) {
              this.lastVH = vh;
              this.lastVW = vw;
              running = false;
            }
          }
        }, delay);
      }
      eventFired = false;
    });
    const { vh, vw } = calculateViewport();
    this.lastVH = vh;
    this.lastVW = vw;
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (const registration of registrations) {
          // unregister service worker
          registration.unregister();
        }
      });
    }
    if (environment.api.includes('dev')) {
      const htmlReference = document.getElementById('main-application');
      if (localStorage.getItem('theme')) {
        htmlReference!.classList.add(localStorage.getItem('theme')!);
        // }else if(!window.matchMedia('(prefers-color-scheme: dark)').matches) {
        //   htmlReference!.classList.add('light-mode');
      }
    }
  }

  ngOnDestroy(): void {
    this.breadcrumbService.destroySubscription();
  }
}
